import React, { Fragment } from 'react';

import StyledButton from '@src/components/wysiwyg_editor/page_content_items/control_panels/StyledButton';
import img from '@images/wysiwyg_editor/control_panels/move_to_cache.svg';
import hoverImg from '@images/wysiwyg_editor/control_panels/move_to_cache-hover.svg';
import { isIE } from 'react-device-detect';

type TProps = {
  onClick: () => void;
};

function MoveToDrafts(props: TProps): React.ReactElement {
  return (
    <StyledButton
      image={img as string}
      hoverImage={hoverImg as string}
      onClick={props.onClick}
    >
      {isIE ? (
        <Fragment>
          Move to
          <br />
          Drafts
        </Fragment>
      ) : (
        'Move to Drafts'
      )}
    </StyledButton>
  );
}

export default MoveToDrafts;
